import { render, staticRenderFns } from "./goFlexHome.vue?vue&type=template&id=553b1458&scoped=true"
import script from "./goFlexHome.vue?vue&type=script&setup=true&lang=js"
export * from "./goFlexHome.vue?vue&type=script&setup=true&lang=js"
import style0 from "./goFlexHome.vue?vue&type=style&index=0&id=553b1458&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "553b1458",
  null
  
)

export default component.exports